<template lang="pug">
  .layout-view
    .layout-view__controls
      .space-between
        v-btn(
          medium
          :disabled="!hasPermission('stock', 'add')"
          @click="openCreateModal")
          v-icon(
            position-left
            font-size="1"
            icon="plus")
          span {{ 'base.add_stock' | translate }}
    
    //- TABLE
    table.table.table--bars
      thead.table__header
        tr.table__row.table__row--head
          th.table__cell {{ 'base.name' | translate }}
          th.table__cell

      v-table-body(
        :cols="2"
        :loading="loading"
        :empty="!items.length")
        tr.table__row.table__row--hover(
          v-for="(item, index) in items"
          :key="index"
          @click="openStock(item)")
          td.table__cell {{ item.name }}
          td.table__cell.table__cell--action(@click.stop)
            v-btn(
              icon
              :disabled="!hasPermission('stock', 'change')"
              @click="openEditModal(item)")
              v-icon(
                font-size="1"
                icon="cog")

    //- TABLE PAGINATION
    ui-pagination(
      v-if="showPagination"
      v-model="page"
      :page-count="pageCount"
      @page-change="pageChangeHandler")
    
    //- CREATE/EDIT MODAL
    v-dialog(
      max-width="400"
      v-model="modals.detail")
      detail-modal(
        :selected="selected"
        @update="loadData"
        @close="modals.detail = false")
</template>

<script>
import api from '@/api'

import DetailModal from './DetailModal'
import UiPagination from '@/components/ui/ui-pagination/UiPagination'

import paginationMixin from '@/mixins/pagination.mixin'

export default {
  name: 'Index',

  mixins: [paginationMixin],

  components: {
    DetailModal,
    UiPagination
  },

  data: () => ({
    modals: {
      detail: false
    },
    selected: null
  }),

  mounted () {
    const company = +this.$route.params.company_id
    this.setupPagination(
      api.stocks.list,
      { company },
      `stocks_${company}`
    )
  },

  methods: {
    openCreateModal () {
      this.selected = null
      this.modals.detail = true
    },

    openEditModal (item) {
      this.selected = item
      this.modals.detail = true
    },

    openStock (item) {
      this.$router.push({
        path: `${this.$route.path}/${item.id}`,
        query: {
          ...this.$route.query,
          stock: item.id,
          is_animalfeed: false
        }
      })
    }
  }
}
</script>
<style scoped>
.table__cell--action {
  width: 1%;
  white-space: nowrap;
  text-align: right;
}
</style>
